module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Maintenance.js"));
	}, "Maintenance");
}